import { Component, Inject, OnInit, ViewChild, Input } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';
import {DialogConfirmDeleteComponent} from '../dialog-confirm-delete/dialog-confirm-delete.component';
import {FiltertrashPipe} from '../pipes/filterPipe';
import {TrashcanService} from '../services/trashcan.service';
import { MOMENT_TOKEN } from '../../../shared/shared.module';

@Component({
  selector: 'app-see-trashcan',
  templateUrl: './see-trashcan.component.html',
  styleUrls: ['./see-trashcan.component.scss'],
  providers: [FiltertrashPipe]
})
export class SeeTrashcanComponent implements OnInit {
  public trashcan: any[]=[];
  listTrashcan = [];
  filteredData = [];
  public show:boolean;
  public menuOptions: any;
  public lastError: string;
  public selectedNode: any;
  public emptyTrash: string;
  public element : string;

  @Input()isUser;
  @Input()userId;
  loadingPage: boolean;
  @ViewChild('menuTrigger')
  public matMenuTrigger: MatMenuTrigger;

  constructor(
    private traschcanService: TrashcanService,
    private dialog: MatDialog,
    @Inject(MOMENT_TOKEN) public moment
  ) {
  }

  ngOnInit() {
   
    this.traschcanService.getDeletedItems().then(res => {
     
      if(this.userId){
        
        res.list.entries.forEach(element => {
        
          if(element.entry.archivedByUser.id ===this.userId){
            this.trashcan.push(element);
          }
        });
      
      }else{
      this.trashcan = res.list.entries;

      }
      this.filterTrashcan('');

      this.loadingPage = false;
    });
    const lang = localStorage.getItem('lang')
    switch (lang){
      case 'fr':
        this.emptyTrash = "Corbeille vide"
        this.element = "Eléments"
        break
      case 'gb':
        this.emptyTrash = "Empty trash"
        this.element = "Elements"
        break
    }
  }


 initialize(){
    this.traschcanService.getDeletedItems().then(res => {
     
      if(this.userId){
        
        res.list.entries.forEach(element => {
        
          if(element.entry.archivedByUser.id ===this.userId){
            this.trashcan.push(element);
          }
        });
      
      }else{
      this.trashcan = res.list.entries;

      }
      this.filterTrashcan('');

      this.loadingPage = false;
    });
  }


  restore(id: string, index: number) {
    this.loadingPage = true;
    this.traschcanService.restore(id).then(res => {
      this.loadingPage = false;

      this.listTrashcan.splice(index, 1);
    }).catch((err) => {
      this.show = true;
    
      setTimeout(function() {
          this.show = false;
      }.bind(this), 3000);
      this.lastError =
      'Erreur de restauration ';
    }).finally(() => {
      this.loadingPage = false;
    });
  }

  public delete(itemname: string, index: number, id: string) {
    this.loadingPage = true;
    const dialogRef = this.dialog.open(DialogConfirmDeleteComponent, {
      width: '50%',
      height: '60%',
      data: {
        itemname: itemname,
        nodeId: id
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadingPage = false;
        this.listTrashcan.splice(index, 1);
        this.initialize();

      }
      this.loadingPage = false;
    });
  }


  public deleteAll(){
    this.loadingPage = true;
    const dialogRef = this.dialog.open(DialogConfirmDeleteComponent, {
      width: '50%',
      height: '60%'
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadingPage = false;
        this.initialize();
      }
      this.loadingPage = false;
    });

  }

  filterTrashcan(search: string) {
    this.listTrashcan = this.trashcan.filter((us: any) => {
      return us.entry.name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
  }
}
